import getStore from '../store/store';
import OwsOptionsBase from '../store/schema/OwsOptionsBase';
import { OwsOptionsFeatureType } from '../store/schema/OwsOptionsFeatureType';

export default function getOptionsForFeature<T extends OwsOptionsBase>(
    feature: OwsOptionsFeatureType
): T {
    return getStore().options[feature] as T;
}
